import PropTypes from 'prop-types'

/**
 * Proptype that represents a unique identity of an entity
 * @typedef {string|number} idPropType
 */
export const idPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number])
